import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap/dist/css/bootstrap.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import VueCarousel from "vue-carousel";
import moment from "moment";
import "material-design-iconic-font/dist/css/material-design-iconic-font.css";
import axios from "axios";
import store from "@/store";
import HighchartsVue from "highcharts-vue";

Vue.config.productionTip = false;
Vue.use(HighchartsVue);
// Vue.prototype.$baseURL = "https://weatherapi.blitztechnology.tech";
Vue.prototype.$baseURL = process.env.VUE_APP_API_URL;
Vue.prototype.$app_title = document.title;

Vue.prototype.$fixedBalai = 10;

Vue.mixin({
  methods: {
    extractUserInfo() {
      let user = localStorage.getItem("user-info") || "{}"; 
      this.user = JSON.parse(user);
    
      // Ensure the user is an object after parsing
      if (typeof this.user !== "object" || this.user === null) {
        this.user = {};
      }
    
      // Extracting values using optional chaining (?.) and defaulting to null if undefined
      this.balai = this.user?.profile?.balai?.id || null;
      this.detBalai = this.user?.profile?.balai || null;
      this.created_by = this.user?.profile?.created_by || null;
      this.role = this.user?.profile?.role || null;
      this.token = this.user?.token || null;
      this.user_id = this.user?.profile?.user?.id || null;
    },
    
    userJSONParse() {
      this.extractUserInfo();
    
      // If the extracted `user` is an object, check for user_id and balai
      if (typeof this.user === "object" && this.user !== null) {
        this.balai = this.$fixedBalai || this.balai;
      } else if (typeof this.user === "string") {
        // Parse the string again and set user-specific data
        let parsedUser = JSON.parse(this.user);
        this.role = parsedUser?.profile?.role || null;
        this.user_id = parsedUser?.profile?.user?.id || null;
        this.balai = parsedUser?.profile?.balai?.id || null;
    
        if (this.role === "is_superuser") {
          this.balai = this.$fixedBalai;  // Set balai to 1 if the user is a superuser
        }
      }
    },
    

    async gBalai() {
      this.balais = await this.fetchData(`${this.$baseURL}/balai/`);
    },
    async gProvinsi() {
      this.provinsis = await this.fetchData(`${this.$baseURL}/provinsi/`);
    },
    async gIcons() {
      this.icons = await this.fetchData(`${this.$baseURL}/icon/`);
    },
    async gStType() {
      this.stationTypes = await this.fetchData(
        `${this.$baseURL}/station-type/`
      );
    },
    async gSensor() {
      this.sensorTypes = await this.fetchData(`${this.$baseURL}/sensor-type/`);
    },
    async gStation() {
      this.stations = await this.fetchData(
        `${this.$baseURL}/station-sensor/${this.balai}`
      );
    },
    async gAllStation() {
      this.stations = await this.fetchData(`${this.$baseURL}/station-sensor/0`);
    },
    async fetchData(url) {
      try {
        if (!this.token) {
          this.logoutUser();
          return null;
        }

        const response = await axios.get(url, {
          headers: {
            Authorization: `Token ${this.token}`,
          },
        });

        return response.data;
      } catch (error) {
        if (error.response) {
          const status = error.response.status;

          // Handle unauthorized and not found errors
          if (status === 401 || status === 403) {
            this.logoutUser();
          }

          console.error(error.response);
        } else {
          console.error(error);
        }

        return null;
      }
    },
    logoutUser() {
      localStorage.clear();
      localStorage.removeItem("access");
      localStorage.removeItem("user-info");
      this.$router.push({ name: "Home" });
      window.location.reload();
      // window.location.reload();
    },
  },
});

Vue.config.productionTip = false;
Vue.prototype.moment = moment;
// Vue.component("v-marker-cluster", Vue2LeafletMarkerCluster);
Vue.use(VueSweetalert2);
Vue.use(VueCarousel);

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

import "bootstrap/dist/js/bootstrap.js";
